import styled from '@emotion/styled';
import React from 'react';
import { Product } from '~/lib/data-contract/salesforce';
import { breakpoints } from '~/theme/breakpoints';
import { findImageGroupBy } from '~/utils/image-group-utils';
import { ProductCard } from './ProductCard';

const ListWrapper = styled.div<{
    hasBorder?: boolean;
    disableSummaryList?: boolean;
    large?: boolean;
}>(({ theme, hasBorder, disableSummaryList }) => ({
    border: hasBorder ? `1px solid ${theme.colors.black}` : 'none',
    borderRadius: hasBorder ? theme.sizes.cornerRadius : 0,
    display: disableSummaryList ? 'none' : 'block',
    'li:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.colors.grey35}`,
    },

    [breakpoints.sm]: {
        border: hasBorder ? `1px solid ${theme.colors.grey35}` : 'none',
        borderRadius: 0,
    },
}));

export const SummaryList = ({
    className,
    products,
    hasBorder,
    productItems = [],
}: Omit<Product, 'id'>) => {
    return (
        <ListWrapper hasBorder={hasBorder} className={className}>
            <ul>
                {productItems.map((item: Product, index: number) => {
                    const product = Array.isArray(products)
                        ? products.find(
                              (product: Product & { quantity: number }) =>
                                  product.id === item.productId,
                          )
                        : undefined;

                    if (!product) return null;

                    const imageGroups = findImageGroupBy(product?.imageGroups, {
                        viewType: 'large',
                        selectedVariationAttributes: { color: product.c_color },
                    });

                    const { images }: any = imageGroups || {};
                    const [image] = images ?? [];

                    return (
                        <li key={`${product.id}-${index}`}>
                            <ProductCard {...{ ...product, ...item, image }} />
                        </li>
                    );
                })}
            </ul>
        </ListWrapper>
    );
};
